import axios from 'axios';

export const resetPassword = async (queryParams) => {
  const { data } = await axios.post('/users/reset-password', queryParams);

  return data;
};
